import HTTP from "@/_helpers/http";
import { CLIENTBANKS__API } from "@/_helpers/urls";
import { CLIENTBANKS__MUTATIONS } from "../mutation-types";
import { CLIENTBANKS__ACTIONS } from "../action-types";
import toast from "@/services/Notification";

const state = {
    banks: [],
    cryptos: []
};

const getters = {};

const mutations = {
    [CLIENTBANKS__MUTATIONS.CLIENTBANKS](state, data) {
        state.banks = data;
    },
    [CLIENTBANKS__MUTATIONS.CLIENTCRYPTOS](state, data) {
        state.cryptos = data;
    },
};

const actions = {
    async [CLIENTBANKS__ACTIONS.CLIENTCRYPTOS]({ commit, state }, id) {
        try {
            const url = `${CLIENTBANKS__API.CLIENTCRYPTOS}/${id}`;
            const response = await HTTP().get(url);

            if (response.status === 200) {
                commit(CLIENTBANKS__MUTATIONS.CLIENTCRYPTOS, response.data);
            } else {
                commit(CLIENTBANKS__MUTATIONS.CLIENTCRYPTOS, []);
            }
        } catch (error) {
            console.log(error);
        }
    },

    async [CLIENTBANKS__ACTIONS.CLIENTBANKS]({ commit, state }, id) {
        try {
            const url = `${CLIENTBANKS__API.CLIENTBANKS}/${id}`;
            const response = await HTTP().get(url);

            if (response.status === 200) {
                commit(CLIENTBANKS__MUTATIONS.CLIENTBANKS, response.data);
            } else {
                commit(CLIENTBANKS__MUTATIONS.CLIENTBANKS, []);
            }
        } catch (error) {
            console.log(error);
        }
    },

    async [CLIENTBANKS__ACTIONS.CREATECLIENTBANK]({ dispatch, state }, data) {
        try {
            const url = `${CLIENTBANKS__API.CREATECLIENTBANK}`;
            const response = await HTTP().post(url, data);

            if (response.status === 200) {
                toast.success("Created Successfully")
                await dispatch(CLIENTBANKS__MUTATIONS.CLIENTBANKS, data.client_account_id);
            }
        } catch (error) {
            console.log(error);
            toast.error(error.response.data.message || "Bank creation failed!")
        }
    },

    async [CLIENTBANKS__ACTIONS.CREATECLIENTCRYPTO]({ dispatch, state }, data) {
        try {
            const url = `${CLIENTBANKS__API.CREATECLIENTCRYPTO}`;
            const response = await HTTP().post(url, data);

            if (response.status === 200) {
                toast.success("Created Successfully")
                await dispatch(CLIENTBANKS__MUTATIONS.CLIENTCRYPTOS, data.user_id);
            }
        } catch (error) {
            console.log(error);
            toast.error(error.response.data.message || "Bank creation failed!")
        }
    },
};

export default {
    namespaced: true,
    strict: process.env.NODE_ENV !== "production",
    state,
    getters,
    mutations,
    actions,
};
